module.exports = __webpack_public_path__ + "img/icon-stockpicker-generating@2x.93ba9906.png";